<template>
    <div class="sidebar">
        <img src="../assets/images/pd2.png" class="logo" @click="toHome">
        <div class="mt30">
            <div class="item" v-for="item in navList" 
                 :class="{'active': currentPath===item.path, 'highlight': currentIndex==item.id}"
                 :key="item.id"
                 @mouseenter="currentIndex=item.id" 
                 @mouseleave="currentIndex=-1"
                 @click="selectMenu(item.path)" 
            >
                <i class="iconfont" :class="item.icon"></i>
                <p class="mt5">{{item.name}}</p>

                <div class="sub_nav" v-if="currentIndex==item.id && item.children && item.children.length>0">
                    <p class="flex flex_ai_c" style="padding: 0 20px;">
                        <i class="iconfont" :class="item.icon" style="font-size: 24px"></i>
                        <span class="ml10 f16">{{item.name}}</span>
                    </p>
                    <div class="mt25">
                        <p  class="child" 
                            :class="{'highlight': hoverSubnav===index || currentSubPath===c.path}" 
                            v-for="(c, index) in item.children" :key="index"
                            @mouseenter="hoverSubnav=index"
                            @mouseleave="hoverSubnav=-1"
                            @click.stop="selectMenu(c.path)"
                        >
                            {{c.name}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {NAV_DATA} from '../utils/hardData'

export default {
    name:'Sidebar',
    data() {
        return {
            navList: NAV_DATA,
            currentIndex: -1,
            hasChidren: false,
            hoverSubnav: -1,
        }
    },
    created() {
        this.getCaseYearList()
    },
    methods: {
        selectMenu(path) {
            console.log(path,999)
            this.$router.push({path})
        },
        getCaseYearList() {
            this.$get('/category/list').then(res=>{
                if(res.errcode===0) {
                    let addPath = []
                    res.content.data.forEach(c=>{
                        let path = { id: c, name: c+'年录取数据', path: '/case/record/'+c }
                        addPath.push(path)
                    })
                    this.navList.forEach(item=>{
                        if(item.path==='/case') {
                            let children = item.children
                            item.children = [...addPath, ...children]
                        }
                    })
                }
            })
        },
        toHome() {
			this.$router.push({path:'/home'})
		},
    },
    computed: {
        currentPath() {
            let route = this.$route
            let {meta, path} = route
            if(meta.activeMenu) {
                return meta.activeMenu
            }
            console.log(88,route)
            return path
        },
        currentSubPath() {
            let path = this.$route.path
            return path
        },
    },
}
</script>

<style lang="scss" scoped>
    .sidebar {
        width: 80px;
        height: 100%;
        background-color: #f0f0f0;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 2;

        .logo {
            width: 60px;
            margin: 0 auto;
            margin-top: 20px;
            cursor: pointer;
        }
        .item {
            padding: 30px 0;
            text-align: center;
            cursor: pointer;
            .icon-shuju {
                font-size: 20px;
            }
        }
        .active {
            background-color: #000;
            color: #fff;
        }
        .highlight {
            color: #E77500;
        }
        .sub_nav {
            width: 200px;
            height: 100%;
            padding: 30px 0;
            background-color: rgba(#000, 0.9);
            color: #fff;
            position: absolute;
            left: 80px;
            top: 0px;
            text-align: left;
            .child {
                cursor: pointer;
                padding: 10px 20px;
            }
        }
            
    }
</style>




// WEBPACK FOOTER //
// src/components/sidebar.vue